import { DetailedHTMLProps, HTMLAttributes } from 'react';

import styles from './PageCol.module.scss';


type TProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
	classNames?: string[];
};

export function PageCol(props: TProps) {
	const {
		classNames: classNamesOuter = [],
		className = '',
		children,
		...restProps
	} = props;

	const classNames = [styles.pageCol, ...classNamesOuter];

	if (className) {
		classNames.push(className);
	}

	return (
		<div className={ classNames.join(' ') } { ...restProps }>
			{ children }
		</div>
	);
}
